import { AccountBasicData } from 'src/app/models/account/account-basic-data.model';
import { AppUser } from '../app-user.model';
/**Solicitud de validación вув de Reniec */
export class ReniecValidationRequest {
    public dni: string;
    /**Lugar de nacimiento */
    public birthPlace: string;
    /**Fecha de nacimiento */
    public birthDate: Date;
    /**Nombre de padre */
    public fatherName: string;
    /**Nombre de madre */
    public motherName: string;
    /**Dígito de verificación del dni */
    public validationDigit: string;
    /**Intentos maximo */
    public isAttemptsMax : boolean;
    /**Numero maximo de intentos */
    public attemptsMax : number;
    /**Codigo de cliente */
    public clientCode: string;
    //**Data basica de cuenta */
    public usuario: AppUser;
}